import { CookieBanner as ReactCookieLaw } from "@palmabit/react-cookie-law";
import "./css/cookie-banner.css";

interface CookieBannerProps {
  wholeDomain?: boolean;
  onAccept?: () => void;
  onAcceptPreferences?: () => void;
  onAcceptStatistics?: () => void;
  onAcceptMarketing?: () => void;
  message?: string;
  policyLink?: string;
  privacyPolicyLinkText?: string;
  necessaryOptionText?: string;
  preferencesOptionText?: string;
  statisticsOptionText?: string;
  marketingOptionText?: string;
  acceptButtonText?: string;
  declineButtonText?: string;
}
export default function CookieBanner({
  wholeDomain = true,
  onAccept,
  onAcceptPreferences,
  onAcceptStatistics,
  onAcceptMarketing,
  message = 'Utilizamos cookies propias y de terceros. Al hacer clic en "Aceptar" permites que recopilemos información.',
  policyLink = "/cookies",
  privacyPolicyLinkText = "Política de cookies",
  necessaryOptionText = "Necesarias",
  preferencesOptionText = "Preferencias",
  statisticsOptionText = "Estadísticas",
  marketingOptionText = "Marketing",
  acceptButtonText = "Aceptar",
  declineButtonText = "Rechazar",
}: CookieBannerProps) {
  return (
    <ReactCookieLaw
      wholeDomain={wholeDomain}
      onAccept={onAccept}
      onAcceptPreferences={onAcceptPreferences}
      onAcceptStatistics={onAcceptStatistics}
      onAcceptMarketing={onAcceptMarketing}
      message={message}
      policyLink={policyLink}
      privacyPolicyLinkText={privacyPolicyLinkText}
      necessaryOptionText={necessaryOptionText}
      preferencesOptionText={preferencesOptionText}
      statisticsOptionText={statisticsOptionText}
      marketingOptionText={marketingOptionText}
      acceptButtonText={acceptButtonText}
      declineButtonText={declineButtonText}
      styles={{
        dialog: { zIndex: 200 },
        container: {},
        message: {
          marginTop: 20,
          marginBottom: 20,
          fontFamily: "var(--font-family-body)",
        },
        selectPane: {
          display: "flex",
          flexWrap: "wrap",
          marginBottom: 20,
        },
        optionWrapper: {},
        optionLabel: {},
        checkbox: {},
        policy: {
          fontFamily: "var(--font-family-body)",
          textDecoration: "underline",
        },
        button: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#C0D72C',
          color: 'white',
        },
      }}
    />
  );
}
